import {postWithAuth} from '@/api'
import {TDateFilter} from '@/types'
import {EpaySummary, POSSummaryResponseModel} from '@/stores'

export const getPOSSummary = (request: TDateFilter) =>
    postWithAuth<POSSummaryResponseModel>('/oppapi/v1/pos/transactions/total-summary', request)

export const getOverviewPOSSummary = (request: TDateFilter, signal?: AbortSignal) =>
    postWithAuth<Omit<EpaySummary, "currency">>('/oppapi/v1/pos/transactions/status-summary', request, undefined, undefined, signal)